import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeProjects: [],
};

export const projectSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    setActiveProjects: (state, action) => {
      state.activeProjects = action.payload;
    },
  },
});

export const { setActiveProjects } = projectSlice.actions;

export default projectSlice.reducer;
